<template>
  <div>
    <b-modal
      id="modal-center"
      size="xl"
      ref="modalCustomerSelect"
      :title="title"
      :no-fade="true"
      hide-footer
      scrollable
    >
      <b-card no-body>
        <b-navbar>
          <b-navbar-nav>
            <b-form inline @submit.prevent="onSearch()">
              <b-form-input
                class="mb-1 mr-2"
                size="sm"
                v-model="filters.query"
                debounce="500"
                placeholder="Поиск"
              />
              <b-form-select
                id="input_town"
                class="mb-1 mr-2"
                size="sm"
                v-model="filters.town"
              >
                <option :value="-1">Все города</option>
                <option v-for="option in towns" :value="option.id">
                  {{ option.name }}
                </option>
              </b-form-select>
              <b-button
                class="mb-1 mr-1"
                size="sm"
                variant="outline-success"
                @click.prevent="onSearch()"
              >
                Применить
              </b-button>
            </b-form>
          </b-navbar-nav>
        </b-navbar>

        <b-table
          id="customers"
          ref="customers"
          class="mb-0"
          striped
          hover
          small
          thead-class="top-fixed-thead thead-light"
          tbody-tr-class="pointer-cell"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :busy.sync="isBusy"
          :items="items"
          :fields="fields"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
          @row-clicked="rowClickHandler"
        >
          <template #cell(phone)="row">
            <a :href=telUrl(row.item.phone)>{{phoneString(row.item.phone)}}</a>
          </template>
          <template #cell(urflag)="row">
            {{urFlagString(row.item.urflag)}}
          </template>
        </b-table>
        <pagination-footer
          :total-rows="totalRows"
          :per-page.sync="perPage"
          @page-click="onPagination"
          @per-page-change="onPerPageChange"
        />
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import customers from "../../network/customers";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import pageSearchService from "../../utilites/pageSearchService";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "CustomerTableSelect",
  components: { PaginationFooter },
  mixins: [
    customers, catalogs,
    helpers, pageSearchService
  ],
  data() {
    return {
      title: 'Выбор заказчика',
      items: [],
      towns: [],
      fields: [
        {
          key: 'name',
          label: this.$t('message.customers.table.name'),
          sortable: true,
        },
        {
          key: 'phone',
          label: this.$t('message.customers.table.phone'),
          sortable: true,
        },
        {
          key: 'address',
          label: this.$t('message.customers.table.address'),
          sortable: true,
        },
        {
          key: 'urflag',
          label: this.$t('message.customers.table.urflag'),
          sortable: true,
          class:'type-width'
        }
      ],
      isBusy: false,
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
        town: -1
      },
    }
  },
  async created() {
    await this.getItems();
  },
  methods: {
    async showModalSelect() {
      this.$refs.modalCustomerSelect.show();
      this.towns = (await this.getTowns({})).data.items;
      this.currentTown = this.towns[0].value;
      await this.getItems();
    },
    hideModal() {
      this.$refs.modalCustomerSelect.hide();
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        town: this.filters.town,
      }

      this.isBusy = true;
      const result = await this.getCustomers(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
    },
    showModal(row, isRead) {
      this.$emit('showModal', row, isRead);
    },
    urFlagString(flag) {
      return flag ? "Юр лицо" : "Юр лицо";
    },
    rowClickHandler(record, index) {
      this.$emit('selectCustomer', record);
      this.hideModal();
    },
    onClear() {
      this.query = "";
      this.$emit('selectCustomer',null);
    },
  },
}
</script>

<style>
.pointer-cell{
  cursor: pointer;
}
.type-width {
  width: 100px;
}

#modal-center .modal-body {
  padding: 0;
}

#customers-pagination ul {
  margin-bottom: 0;
}

#footer {
  position: sticky;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerTableSelect.vue